import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Função',
    path: '/pessoal/pesfuncao',
    name: 'pesfuncao',
    component: () => import('@/views/pessoal/pesfuncao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FUNCOESNOVO_MENU_1400400199],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Função',
    path: '/pessoal/pesfuncao/cadastro/:id?',
    parent: 'pesfuncao',
    name: 'pesfuncao_create',
    component: () => import('@/views/pessoal/pesfuncao/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.FUNCOESNOVO_MENU_1400400199],
    },
    goesToMenu: true,
  },
]
